import config from '../../../config';

const apiV1Url = config.apiUrl();
const baseUrl = `${apiV1Url}/FineImage`;

export default {
  getSyntellFineImageUrl: (): string => `${baseUrl}/syntell`,
  getFineImageUrl: (): string => baseUrl,
};
